/**
* 省单选，市多选级联选择
*/ 
<template>
  <div class="form-item flex-left">
    <el-select
      v-model="fatherVal"
      :size="size"
      clearable
      @change="handleChangeFather"
      filterable
      :filter-method="filterFater"
      :disabled="disabled"
    >
      <el-option
        v-for="item in filterList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <div class="wrapper_children_list">
      <el-select
        v-model="childrenVal"
        :size="size"
        clearable
        multiple
        collapse-tags
        filterable
        :filter-method="filterChildren"
        @change="handleChangeChildren"
        :disabled="disabled"
      >
        <div class="wrapper_checkbox">
          <el-checkbox  v-model="selectAllChecked" @change="selectAll">全选</el-checkbox>
        </div>
        <el-option
          v-for="item in filterChildrenList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "default"
    },
    value: {
      type: Object,
      default() {
        return {
          fatherVal: "",
          childrenVal: ""
        };
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      fatherVal: (this.value && this.value["fatherVal"]) || "",
      childrenVal: (this.value && this.value["childrenVal"]) || "",
      childrenOptions: [],
      filterList: this.options,
      filterChildrenList: [],
      selectAllChecked: false
    };
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fatherVal = (this.value && this.value["fatherVal"]) || "";
          this.childrenVal = (this.value && this.value["childrenVal"]) || "";
        }
      },
      deep: true
    }
  },
  methods: {
    filterFater(query) {
      if (!query) {
        this.filterList = this.options;
      } else {
        this.filterList = this.options.filter(
          item => item.label.indexOf(query) !== -1
        );
      }
    },
    filterChildren(query) {
      if (!query) {
        this.filterChildrenList = this.childrenOptions;
      } else {
        this.filterChildrenList = this.childrenOptions.filter(
          item => item.label.indexOf(query) !== -1
        );
      }
      if(this.filterChildrenList.length !== this.childrenVal.length){
        this.selectAllChecked = false
      }
      console.log("this.filterChildrenList: ", this.filterChildrenList);
    },
    handleChangeFather(data, isChange = true) {
      
      // data是value值
      if (isChange) {
        this.childrenVal = [];
        this.selectAllChecked = false;
      }

      if (!data) {
        this.childrenOptions = [];
      } else {
        this.childrenOptions =
          this.filterList.find(item => item.value === data).options || [];
      }
      this.filterChildrenList = this.childrenOptions;
      this.changeData(data, this.childrenVal);
    },
    handleChangeChildren(data) {
      if (data.length === this.filterChildrenList.length) {
        this.selectAllChecked = true;
      } else {
        this.selectAllChecked = false;
      }
      this.changeData(this.fatherVal, data);
    },
    selectAll() {
      // 手动全选
      // debugger
      let selectedArray = [];
      if (this.selectAllChecked) {
        selectedArray = this.filterChildrenList.map(item => {
          return item.value;
        });
      }
      this.childrenVal = selectedArray;
      this.handleChangeChildren(selectedArray)
    },
    changeData(fatherVal, childrenVal) {
      this.$emit("input", {
        fatherVal,
        childrenVal
      });
    }
  },
  created() {
    // console.log("childCreated")
    if (this.value.fatherVal && this.fatherVal) {
      this.handleChangeFather(this.fatherVal, false);
    }
  },
  mounted() {
    // console.log("childMounted")
  }
};
</script>
<style lang="scss" scoped>
.flex-left {
  display: flex;
  justify-content: flex-left;
}
.wrapper_children_list {
  margin-left: 10px;
}
.wrapper_checkbox{
    width: 100%;
    padding-left: 20px;
    height: 34px;
    font-size: 20px;
    line-height: 28px;
    /deep/ .el-checkbox {
      width: 100%;
  }
}


</style>


// WEBPACK FOOTER //
// src/lib/customSecLevelCascader.vue